import { capitalize } from 'lodash';
import Ui3DotsMenu from '../../../dictionaries/Ui3DotsMenu.dic';
import {
  NOT,
  YES
} from '../../../lib/Boolean.lib';
import openWindow from '../../../lib/Browser/openWindow.async';
import fetchCandidateResume from '../../../lib/Candidate/fetchCandidateResume.async';
import Core from '../../../lib/Core';
import globalErrorHandler from '../../../lib/Error/globalErrorHandler.fun';
import {
  Fun
} from '../../../lib/Function.lib';
import useState from '../../../lib/hooks/useState.hook';
import {
  compileText,
  Str,
  trim
} from '../../../lib/String.lib';
import {
  matchLocation
} from '../../../lib/URL.lib';
import {
  mapWrapper
} from '../../Layout/Libraries/Theme.lib';
import Box from '../../Layout/Wrappers/Box';
import Icon from '../../Layout/Wrappers/Icon';
import Menu from '../../Layout/Wrappers/Menu';
import Typography from '../../Layout/Wrappers/Typography';
import getRemoteCandidateResumePdfUrl from './Libraries/getRemoteCandidateResumePdfUrl.fun';

export default function ActionComponentCandidateResumePdf({
  candidate = {},
  jobId = '',
  employerId = '',
  children,
  wrapperProps = {},
  ...props
}) {
  const [state, updateState] = useState();

  const URL__CANDIDATE__RESUME = getRemoteCandidateResumePdfUrl(candidate);
  const YES__URL__CANDIDATE__RESUME = YES(trim(URL__CANDIDATE__RESUME));
  const NOT__URL__CANDIDATE__RESUME = NOT(YES__URL__CANDIDATE__RESUME);

  if (NOT__URL__CANDIDATE__RESUME) { return null; }

  const fetchHighlights = async () => {
    try {
      await updateState({ loading: true, error: false });
      const result = await fetchCandidateResume({
        key: 'highlighted',
        type: 'blob',
        candidate,
        jobId,
        employerId,
        source: 'ActionComponentCandidateResumePdf',
      });
      await updateState({ loading: false, error: false });
      return result;
    }
    catch (error) {
      Core.showError('This document is not available');
      await updateState({ loading: false, error });
    }
  }
  const onClickAction = async (event) => {
    event.stopPropagation();
    try {
      const highlights = await fetchHighlights();
      openWindow({
        title: getTitle(),
        url: highlights,
        source: 'ActionComponentCandidateResumePdf',
      });
      Fun(props.onClick)(event);
    }
    catch (error) {
      globalErrorHandler(error);
    }
  }
  const statusIcon = (
    (state.loading || state.error) &&
    (
      <Icon outlined
        icon={state.loading ? 'hourglass_empty' : 'error'}
        title={
          trim(Str(state.error).split(':').pop()) ||
          (state.loading && 'Loading...')
        }
        className='mx-1'
      />
    )
  );
  mapWrapper({
    role: 'ActionComponentCandidateResumePdf',
    props: wrapperProps,
    assign: {
      ...props,
      onClick: onClickAction,
      disabled: (state.loading || state.error)
    }
  });
  return (
    (
      children
    ) ? (
      <Box {...wrapperProps}>
        {statusIcon || children}
      </Box>
    ) : (
      <Menu.Item divider {...wrapperProps}>
        <Typography blackDark mr>
          {getTitle()}
        </Typography>
        {statusIcon}
      </Menu.Item>
    )
  )
}

function getTitle() {
  return capitalize(
    compileText(Ui3DotsMenu.Candidate.viewResumeHighlights, {
      PREFIX: (
        matchLocation(/\/(candidates|create|edit)/i)
          ? ''
          : Ui3DotsMenu.Candidate.PREFIX
      ),
    })
  );
}
